import { defineComponent as _defineComponent } from 'vue'
import type { Component } from 'vue'
import { ref } from 'vue'
import BaseDropdown from '~/components/new/ui/BaseDropdown.vue'
export type DropdownBlockProps = {
    item?: {
        text?: string,
        title: string,
        iconComponent: Component
    },
    content?: 'html' | 'text'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownBlock',
  props: {
    item: null,
    content: null
  },
  setup(__props: any) {



const isActive = ref(false)
const hovered = ref(false)


return { __sfc: true,isActive, hovered, BaseDropdown }
}

})